var map = {
	"./Bitmap.png": "efd3",
	"./Shape.svg": "c7d3",
	"./VIP-icon/1.png": "2f8cc",
	"./VIP-icon/10.png": "c358",
	"./VIP-icon/2.png": "27bb",
	"./VIP-icon/3.png": "c3d5",
	"./VIP-icon/4.png": "9ad8",
	"./VIP-icon/5.png": "bb52",
	"./VIP-icon/6.png": "e937",
	"./VIP-icon/7.png": "47bf",
	"./VIP-icon/8.png": "1ca8",
	"./VIP-icon/9.png": "46e8",
	"./feedback.svg": "784f",
	"./file.svg": "fe3c",
	"./handout-icon/audio.svg": "3fc2",
	"./handout-icon/fmt.svg": "5f16",
	"./handout-icon/pdf.svg": "b088",
	"./handout-icon/ppt.svg": "80e7",
	"./handout-icon/video.svg": "aeef",
	"./handout-icon/word.svg": "39d4",
	"./image.svg": "d17f",
	"./package.svg": "3349",
	"./pdf.svg": "4e08",
	"./photo.svg": "d740",
	"./star.svg": "ec6f",
	"./stared.svg": "eb24",
	"./word.svg": "721a",
	"./叹号.svg": "1b62",
	"./失败.svg": "d113",
	"./完成.svg": "dcea",
	"./密码.svg": "f26f",
	"./对号.svg": "b18a",
	"./搜索.svg": "d092",
	"./眼睛.svg": "0508",
	"./闭眼.svg": "9cc0",
	"./问号.svg": "7f65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";